import React, { useEffect, useState } from "react";
import api from "../lib/api"
import { Link } from 'react-router-dom';

const EmployeeStressCheck = () => { 
    const [availableChecks, setAvailableChecks] = useState([]); 
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("データを取得しています...");

    useEffect(() => {
        const fetchChecks = async () => {
            try {
                const res = await api.get("/stresschecks/");
                const list = Array.isArray(res.data) ? res.data : [];
                setAvailableChecks(list);
                setMessage(list.length === 0 ? "現在、ストレスチェックが存在しません。" : "");
            } catch (err) {
                setMessage("ストレスチェック情報の取得に失敗しました。");
                setAvailableChecks([]);
            } finally {
                setLoading(false);
            }
        };
        fetchChecks();
    }, []);

  
    const buttonGroup = {
        backgroundColor: "#03a9f4",
        color: "white",
        borderRadius: "8px",
        padding: "10px 25px",
        fontWeight: "bold",
        fontSize: "1rem",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
        textDecoration: "none",
    }
    
    if (loading) {
        return <div style={{ padding: "2rem", textAlign: "center" }}><h2>{message}</h2></div>;
    }

    return (
        <div style={{ 
            padding: 0 
        }}>
            <h2 style={{
                textAlign: "center", 
                fontSize: "1.5rem",
                padding: "20px 0" 
            }}>
                ストレスチェック 
            </h2>
            {availableChecks.length === 0 && (
                <p style={{ 
                    color: 'red', 
                    textAlign: 'center', 
                    padding: '20px' 
                }}>
                    {message}
                </p>
            )}

            <ul style={{ 
                listStyle: 'none', 
                padding: 0, 
                margin: 0 
            }}>
                {availableChecks.map(check => {
                    const fmt = (d) => {
                        if (!d) return '';
                        const s = String(d);
                        if (s.length >= 10) return `${s.slice(0, 4)}/${s.slice(5, 7)}/${s.slice(8, 10)}`;
                        return s;
                    };
                    return (
                    <li key={check.id} style={{ 
                        borderBottom: '1px solid #eee', 
                        padding: '15px 20px', 
                        margin: '0', 
                        backgroundColor: '#fff',
                        boxSizing: 'border-box', 
                        width: '100%',
                    }}>
                        <h3 style={{ margin: '0 0 5px 0', color: '#1a1a2e', fontWeight: 600 }}>
                            {check.title}
                        </h3>
                        <p style={{ margin: '5px 0', color: '#444' }}>
                            期間: {fmt(check.start_date)} ～ {fmt(check.end_date)}
                        </p>
                        <a
                            href={check.form_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                display: "inline-block",
                                padding: "8px 15px",
                                backgroundColor: "#28a745",
                                color: "#fff",
                                textDecoration: "none",
                                borderRadius: "5px",
                                marginTop: "10px",
                                fontWeight: 600
                            }}
                        >
                            開く
                        </a>
                    </li>
                    );
                })}
            </ul>

            <div style={{ 
                marginTop: "30px", 
                textAlign: "center"
            }}>
                <Link to="/card_back" className="btn-back" style={buttonGroup}> 
                    戻る
                </Link>
            </div>
        </div>
    );
};

export default EmployeeStressCheck;